<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <label class="done">Registration</label>
                                    <label class="active">Payment</label>
                                    <label class="passive" href="#">Visa Form</label>
                                    <label class="passive" href="#">Documents</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 offset-md-1">
                            <div class="reg-form payment top124">
                                <div v-if="dataReceived" class="reg-completed">
                                    <div class="form-group row">
                                        <div class="payment-box">
                                            <p>
                                                You requested the {{model.VisaCategory}} ({{model.VisaType}}) visa. The requested length of stay is {{model.LengthOfStay}} days.
                                                <div v-if="model.Payment > 0" class="price">{{model.Payment}} Pula</div>
                                                <div v-else class="price">Exempt</div>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div v-if="shouldPay" class="form-group row">
                                        <form action="https://www.vcs.co.za/vvonline/vcspay.aspx" method="post">
                                            <!-- 3282:prod, 9023:test-->
                                            <input type="hidden" name="p1" value="3282">
                                            <input type="hidden" name="p2" v-model=model.Seq>
                                            <input type="hidden" name="p3" v-model=model.Description>
                                            <input type="hidden" name="p4" v-model=model.Payment>
                                            <input type="hidden" name="UrlsProvided" value="Y">
                                            <input type="hidden" name="ApprovedUrl" v-model=setPath.ok>
                                            <input type="hidden" name="DeclinedUrl" v-model=setPath.not_ok>

                                            <input type="hidden" name="CardholderEmail" v-model=model.Email>
                                            <p class="continue-msg">Click Pay Now for Payment</p>
                                            <div class="submit-row">
                                                <button type="submit" class="btn-submit">Pay Now</button>
                                                <p class="continue-about top32">You will be transferred to the Payment System</p>
                                            </div>
                                        </form>

                                    </div>

                                    <div v-else class="form-group row">
                                        <div class="col-sm-12 submit-row">
                                            <router-link to="/appdetails">
                                                <button type="button" class="btn-primary">Fill the Visa Form</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Registration</label>
                        <label class="active">Payment</label>
                        <label class="passive" href="#">Visa Form</label>
                        <label class="passive" href="#">Documents</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 app top64">
                    <div class="reg-form payment">
                        <div v-if="dataReceived" class="reg-completed">
                            <div class="form-group row">
                                <div class="payment-box">
                                    <p>
                                        You requested the {{model.VisaCategory}} ({{model.VisaType}}) visa. The requested length of stay is {{model.LengthOfStay}} days.
                                        <div v-if="model.Payment > 0" class="price">{{model.Payment}} Pula</div>
                                        <div v-else class="price">Exempt</div>
                                    </p>
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div v-if="shouldPay" class="form-group row">
                                <form action="https://www.vcs.co.za/vvonline/vcspay.aspx" method="post">
                                    <!-- test:9023, prod:3282 --> 
                                    <input type="hidden" name="p1" value="3282">
                                    <input type="hidden" name="p2" v-model=model.Seq>
                                    <input type="hidden" name="p3" v-model=model.Description>
                                    <input type="hidden" name="p4" v-model=model.Payment>
                                    <input type="hidden" name="UrlsProvided" value="Y">
                                    <input type="hidden" name="ApprovedUrl" v-model=setPath.ok>
                                    <input type="hidden" name="DeclinedUrl" v-model=setPath.not_ok>
                                 
                                    <input type="hidden" name="CardholderEmail" v-model=model.Email>
                                    <p class="continue-msg">Click Pay Now for Payment</p>
                                    <div class="submit-row">
                                        <button type="submit" class="btn-submit">Pay Now</button>
                                        <p class="continue-about top32">You will be transferred to the Payment System</p>
                                    </div>
                                </form>

                            </div>

                            <div v-else class="form-group row">
                                <div class="col-sm-12 submit-row">
                                    <router-link to="/appdetails">
                                        <button type="button" class="btn-primary">Fill the Visa Form</button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'PrePayment',

        data: () => ({
            model: {},
            shouldPay: false,
            dataReceived: false,
            ok_path: "",
            not_ok_path: ""
        }),
        mounted() {
            this.getPrePayment()  
        },
        computed: {
            setPath: function () {
                var paths = { "ok": this.$rootip + "/#/paymentok", "not_ok": this.$rootip + "/#/paymentnotok" }
                //var paths = { "ok": "81.218.77.178:8080" + "/#/paymentok", "not_ok": "81.218.77.178:8080" + "/#/paymentnotok" }
                //console.log(this.$rootip)
                return paths
            },
            appNum: function () {
                //return this.$store.state.appNum;
                return this.$cookie.get('eVisaAppID');
            }
           
        },
        methods: {
            async getPrePayment() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/prepayment')
                    const data = await response.json()
                    this.model = data.Model
                    //this.model.Description = this.model.VisaCategory + " (" + this.model.VisaType + "). App No: " + this.model.ID
                    //this.model.Description = this.model.VisaCategory + " " + this.model.VisaType
                    this.model.Description = this.model.VisaCategory + " " + this.model.VisaType + " App No " + this.model.ID
                    this.dataReceived = true;
                    this.shouldPay = this.model.Payment > 0
                } catch (error) {
                    //console.error(error)
                }
            },
        }
    }
</script>
